module.exports = __webpack_public_path__ + "img/product-placeholder-85.a2826c3.png";